/*#
# Autor: Karen Yunuen Pozos Arias
# DEV - IBL
#*/
import React from "react";
import {Card, CardActions, CardContent, FormHelperText} from "@mui/material";
import {CustomStyleCardContainer, CustomStyleCardContainerRequired, CustomStyleFormHelperText} from "./Styles";
import {Box} from "@mui/system";
import {useTranslation} from "react-i18next";

/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 *
 * @Description Card container with dynamic content
 * @param String title: Title for the card container (optional)
 * @param String subtitle: Subtitle for the card container (optional)
 * @param Array<JSX.Element> children: List of JSX elements (required)
 * @param Array<JSX.Element> actions: List of JSX elements (optional)
 * @param {String} cardActionsClass - Extra className to apply to the CardActions container (optional)
 * @param {String} cardContentClass - Extra className to apply to the CardContent container (default height-320px)
 * @returns {JSX.Element}
 */

const CustomCardContainer = ({title, subtitle, children, actions, emptyFields=false, cardActionsClass, cardContentClass='h-320px'}) => {
    const { t } = useTranslation();
    return  <>
        <Box sx={emptyFields ? CustomStyleCardContainerRequired(): CustomStyleCardContainer()} >
            {title && <span className={"custom-title-card"}>{t(title)}</span>}
            {subtitle && <div className='col-12 p-0'>{subtitle}</div>}
            <Card  className={"custom-card-container" }>
                <CardContent className={cardContentClass}>
                    {children}
                </CardContent>
                {actions &&
                    <CardActions className={`justify-content-center ${cardActionsClass || ''}`}>
                        {actions}
                    </CardActions>
                }
            </Card>
        </Box>
        {emptyFields && (
            <FormHelperText id="outlined-weight-helper-text" error={true}  sx={CustomStyleFormHelperText}>
                {t('requiredField')}
            </FormHelperText>
        )}
        </>

}

export default CustomCardContainer
